import { LOCALES } from "./locales"

export const messages = {
    [LOCALES.ENGLISH]: {
        "reloadPinNav": "reload pin",
        // login page
        "lucky.serial": "Lucky Serial",
        "login.username": "Username",
        "login.password": "Password",
        "login.button": "Login",
        "login.username.error": "Please enter your login username",
        "login.password.error": "Please enter your password",
        "login.error": "Error",
        "login.failed": "These credentials do not match our records.",

        // navbar
        "search": "Search",
        "redeemed": "Redeemed",
        "unclaimed": "Unclaimed",
        "no.such.record": "No Such Record",
        "change.password": "Change Password",

        // sidebar
        "dashboardNav": "Dashboard",
        "luckySerialNav": "Lucky Serial",
        "generateSerialNav": "Generated Serial",
        "allSerialNav": "All Serial",
        "unclaimedSerialNav": "Active Serial",
        "claimedSerialNav": "Redeemed Serial",
        "angpowNav": "Money Packet",
        "logoutNav": "Logout",

        //page: dashboard
        "dashboard": "Dashboard",
        "dash.text": "Lucky Serial",
        "total.generated": "Total Generated",
        "total": "Total",
        "total.amount.generated": "Amount Generated",
        "total.amount.redeemed": "Amount Redeemed",
        "total.count.redeemed": "Total Count Redeemed",
        "total.rm.redeemed": "Total Amount Redeemed",
        "total.redeemed.count": "Total Redeemed (Count)",
        "most.redeemed.percentage": "Most Redeemed (%)",
        "top10": "Top 10 Redeemed Account",

        // date filter
        "all.time": "ALL TIME",
        "this.year": "THIS YEAR",
        "this.month": "THIS MONTH",
        "last.week": "LAST WEEK",
        "this.week": "THIS WEEK",
        "yesterday": "YESTERDAY",
        "today": "TODAY",
        "start.date": "From",
        "end.date": "To",

        // Chart
        "chart.redeemed": "Redeemed",
        "chart.sold": "Sold",

        //page: generate
        "generate.serial": "Generate Serial",
        "top.up.credit": "Top Up Credit",
        "generate.amount": "Credit",
        "generate.quantity": "Quantity",
        "generate.buyer": "Buyer Username",
        "generate.button": "Generate",
        "copy": "Copy",
        "serial.number": "Serial Number",
        "serial.credit": "Credit",
        "serial.buyer": "User",
        "serial.purchase.date": "Purchase Date",
        "export.csv": "Export",
        "credit.error": "This field must not be empty.",
        "amount.error": "This field must not be empty.",
        "remark.error": "This field must not be empty.",

        // page: all serial
        "all.serial": "All Serial",
        "redeemed.account": "Acount Redeem",
        "redeemed.date": "Date Redeem",
        "serial.status": "Status",
        "delete": "Delete",
        "delete.confirmation.message": "Are you sure you want to delete this entry?",

        // page: active serial
        "valid.serial": "Active Serial",

        // page: invalid serial
        "invalid.serial": "Redeemed Serial",

        // change password
        "change.password": "Change Password",
        "current.password": "Current Password",
        "new.password": "New Password",
        "confirm.password": "Confirm Password",
        "success.message": "Your password has been changed successfully.",
        "go.to.home": "Go to home",
        "current.empty": "Please enter your current password.",
        "new.empty": "Please enter your new password",
        "confirm.empty": "Please confirm your new password.",
        "confirm.failed": "Your password does not match.",
        "save": "Save",
        "success.text": "Your password has been changed succesfully.",

        // page: angpao
        "angpaoId": "Id",
        "angpao_credit": "Total Amount",
        "angpao_owner": "From",
        "angpao_type": "Type",
        "createdAt": "Creation Date",
    },


    [LOCALES.CHINESE]: {
        // login page
        "lucky.serial": "幸运序号",
        "login.username": "用户名",
        "login.password": "密码",
        "login.button": "登录",
        "login.username.error": "请输入您的用户名",
        "login.password.error": "请输入您的密码",
        "login.error": "Error",
        "login.failed": "抱歉，您的资料不存在我们的记录",

        // navbar
        "search": "搜索",
        "redeemed": "已兑换",
        "unclaimed": "未被兑换",
        "no.such.record": "无此记录",
        "change.password": "更换密码",

        // sidebar
        "dashboardNav": "仪表盘",
        "luckySerialNav": "幸运序号",
        "generateSerialNav": "生成序号",
        "allSerialNav": "所有序号",
        "unclaimedSerialNav": "未兑换序号",
        "claimedSerialNav": "已兑换序号",
        "angpowNav": "红包",
        "logoutNav": "退出",

        //page: dashboard
        "dashboard": "仪表盘",
        "dash.text": "幸运序号",
        "total": "总数",
        "total.amount.generated": "生成金额",
        "total.amount.redeemed": "兑换金额",
        "total.count.redeemed": "兑换",
        "total.rm.redeemed": "总兑换金额",
        "total.generated": "总生成",
        "total.redeemed.count": "总兑换量",
        "most.redeemed.percentage": "兑换占比",
        "top10": "前10兑换账号",

        // date filter
        "all.time": "全部",
        "this.year": "今年",
        "this.month": "这个月",
        "last.week": "上个星期",
        "this.week": "这个星期",
        "yesterday": "昨天",
        "today": "今天",
        "start.date": "从",
        "end.date": "到",

        // Chart
        "chart.redeemed": "兑换",
        "chart.sold": "售出",

        //page: generate
        "generate.serial": "生成序号",
        "top.up.credit": "充值",
        "generate.amount": "金额",
        "generate.quantity": "数量",
        "generate.buyer": "备注买家",
        "generate.button": "生成",
        "copy": "复制",
        "serial.number": "序号",
        "serial.credit": "金额",
        "serial.buyer": "买家",
        "serial.purchase.date": "购买日期",
        "export.csv": "导出 CSV",
        "credit.error": "须填上序号金额",
        "amount.error": "须填上序号金额",
        "remark.error": "须填上序号金额",

        // page: all serial
        "all.serial": "所有序号",
        "redeemed.account": "兑换账号",
        "redeemed.date": "兑换日期",
        "serial.status": "状态",
        "delete": "删除",

        // page: active serial
        "valid.serial": "未兑换序号",

        // page: invalid serial
        "invalid.serial": "已兑换序号",

        // change password
        "change.password": "更换密码",
        "current.password": "当前密码",
        "new.password": "新密码",
        "confirm.password": "确定新密码",
        "success.message": "密码已成功被更换。",
        "go.to.home": "首页",
        "current.empty": "请输入您现在的密码.",
        "new.empty": "请输入您的新密码",
        "confirm.empty": "请确认您的新密码",
        "confirm.failed": "您输入的密码不正确",
        "save": "保存",        
        "success.text": "Your password has been changed succesfully.",

        // page: angpao
        "angpaoId": "红包 ID",
        "angpao_credit": "总价值",
        "angpao_owner": "创建人",
        "angpao_type": "类别",
        "createdAt": "创建日期",
    },


    [LOCALES.MALAY]: {
        // login page
        "lucky.serial": "Lucky Serial",
        "login.username": "Nama Pengguna",
        "login.password": "Kata Laluan",
        "login.button": "Masuk",
        "login.username.error": "Sila masukkan nama pengguna log masuk anda",
        "login.password.error": "Sila masukkan kata laluan anda",
        "login.error": "Error",
        "login.failed": "Bukti kelayakan ini tidak sepadan dengan rekod kami.",

        // navbar
        "search": "Carian",
        "redeemed": "Sudah Ditebus",
        "unclaimed": "Belum Ditebus",
        "no.such.record": "Tiada Rekod",
        "change.password": "Tukar Kata Laluan",

        // sidebar
        "dashboardNav": "Papan Pemuka",
        "luckySerialNav": "Lucky Serial",
        "generateSerialNav": "Menjana Nombor Siri",
        "allSerialNav": "Semua Nombor Siri",
        "unclaimedSerialNav": "Siri Belum Ditebus",
        "claimedSerialNav": "Siri Ditebus",
        "angpowNav": "Duit Paket",
        "logoutNav": "Log Keluar",

        //page: dashboard
        "dashboard": "Papan Pemuka",
        "dash.text": "Lucky Serial",
        "total": "Jumlah",
        "total.amount.generated": "Dijana",
        "total.amount.redeemed": "Ditebus",
        "total.count.redeemed": "Jumlah Kiraan Ditebus",
        "total.rm.redeemed": "Jumlah Amaun yang Ditebus",
        "total.generated": "Jumlah Menjana",
        "total.redeemed.count": "Jumlah Ditebus",
        "most.redeemed.percentage": "Paling Banyak Ditebus",
        "top10": "10 Teratas Akaun yang Ditebus",

        // date filter
        "all.time": "SEMUA",
        "this.year": "TAHUN INI",
        "this.month": "BULAN INI",
        "last.week": "MINGGU LEPAS",
        "this.week": "MINGGU INI",
        "yesterday": "SEMALAM",
        "today": "HARI INI",
        "start.date": "Dari",
        "end.date": "Sampai",

        // Chart
        "chart.redeemed": "PENEBUSAN",
        "chart.sold": "DIJUAL",

        //page: generate
        "generate.serial": "Menjana Nombor Siri",
        "top.up.credit": "Tambah Nilai Kredit",
        "generate.amount": "Kredit",
        "generate.quantity": "Kuantiti",
        "generate.buyer": "Nama Pembeli",
        "generate.button": "Menjana",
        "copy": "Salinan",
        "serial.number": "Nombor Siri",
        "serial.credit": "Kredit",
        "serial.buyer": "Pembeli",
        "serial.purchase.date": "Tarikh Pembelian",
        "export.csv": "Eksport CSV",
        "credit.error": "Tidak boleh diletakkan kosong.",
        "amount.error": "Tidak boleh diletakkan kosong.",
        "remark.error": "Tidak boleh diletakkan kosong.",

        // page: all serial
        "all.serial": "Semua Nombor Siri",
        "redeemed.account": "Akaun Penebusan",
        "redeemed.date": "Tarikh Penebusan",
        "serial.status": "Taraf",
        "delete": "Padam",

        // page: active serial
        "valid.serial": "Siri Belum Ditebus",

        // page: invalid serial
        "invalid.serial": "Siri Ditebus",

        // change password
        "change.password": "Tukar Kata Laluan",
        "current.password": "Kata Laluan Semasa",
        "new.password": "Kata Laluan Baharu",
        "confirm.password": "Mengesahkan Kata Laluan Baharu",
        "current.empty": "Sila masukkan kata laluan semasa anda.",
        "new.empty": "Sila masukkan kata laluan baharu anda.",
        "confirm.empty": "Sila sahkan kata laluan baharu anda.",
        "confirm.failed": "Kata laluan baharu anda tidak sepadan.",
        "save": "Menyerahkan",
        "success.text": "Kata laluan anda telah berjaya ditukar.",

        // page: angpao
        "angpaoId": "Id",
        "angpao_credit": "Jumlah",
        "angpao_owner": "Dari",
        "angpao_type": "Jenis",
        "createdAt": "Tarikh",
    },
}